import {PageCollection, HttpExclude} from 'simpli-web-sdk'
import {InternationalRequest} from '@/helpers/InternationalRequest'
import {VisualizationMode} from '@/model/resource/VisualizationMode'

/* TODO: review generated class */
@HttpExclude()
export class VisualizationModeCollection extends PageCollection<
  VisualizationMode
> {
  constructor() {
    super(VisualizationMode)
  }

  queryAsPage() {
    return this.listVisualizationMode()
  }

  async listVisualizationMode() {
    return await InternationalRequest.get(`/admin/visualization-mode`, {
      params: this.params,
    })
      .name('listVisualizationMode')
      .as(this)
      .getResponse()
  }

  async listCsvVisualizationMode() {
    return await InternationalRequest.get(`/admin/visualization-mode/export`, {
      params: this.params,
    })
      .name('listCsvVisualizationMode')
      .as(this)
      .getResponse()
  }
}
